<template>
  <div class="app-wrapper">
    <!-- 广告以及菜单栏 -->
    <!-- home header 包括logo 搜索框等 -->
    <mall-header></mall-header>
    <!-- 菜单 -->
    <!-- <category-menu></category-menu> -->
    <!-- 内容区域 -->
    <div
      v-if="this.$route.meta.isKeepAlive === false"
      class="main-container"
    >
      <router-view></router-view>
    </div>
    <div
      v-else
      class="main-container"
    >
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import mallHeader from "views/common/mall-header.vue";
// import categoryMenu from 'views/common/category-menu.vue';

export default {
  components: {
    mallHeader,
    // categoryMenu
  },
};
</script>
<style src="../../../assets/css/home_header.css" />



// WEBPACK FOOTER //
// index.vue?51d5b7a6